/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { c as components } from './_chunks/dep-d2b3438a.mjs';
import './common.mjs';
export { Button } from './button/index.mjs';
export { Icon } from './icon/index.mjs';
export { Link } from './link/index.mjs';
export { Col, Row } from './grid/index.mjs';
export { Aside, Content, Footer, Header, Layout } from './layout/index.mjs';
export { Divider } from './divider/index.mjs';
export { Space } from './space/index.mjs';
export { Affix } from './affix/index.mjs';
export { Anchor, AnchorItem, AnchorTarget } from './anchor/index.mjs';
export { Breadcrumb, BreadcrumbItem } from './breadcrumb/index.mjs';
export { Dropdown, DropdownItem, DropdownMenu } from './dropdown/index.mjs';
export { HeadMenu, Menu, MenuGroup, MenuItem, Submenu } from './menu/index.mjs';
export { Pagination, PaginationMini } from './pagination/index.mjs';
export { StepItem, Steps } from './steps/index.mjs';
export { TabPanel, Tabs } from './tabs/index.mjs';
export { StickyItem, StickyTool } from './sticky-tool/index.mjs';
export { BackTop } from './back-top/index.mjs';
export { AutoComplete, HighlightOption } from './auto-complete/index.mjs';
export { Cascader, CascaderPanel } from './cascader/index.mjs';
export { Checkbox, CheckboxGroup } from './checkbox/index.mjs';
export { DatePicker, DatePickerPanel, DateRangePicker, DateRangePickerPanel } from './date-picker/index.mjs';
export { Form, FormItem } from './form/index.mjs';
export { InputAdornment } from './input-adornment/index.mjs';
export { Input, InputGroup } from './input/index.mjs';
export { InputNumber } from './input-number/index.mjs';
export { Radio, RadioButton, RadioGroup } from './radio/index.mjs';
export { Option, OptionGroup, Select } from './select/index.mjs';
export { Slider, SliderButton } from './slider/index.mjs';
export { Switch } from './switch/index.mjs';
export { TagInput } from './tag-input/index.mjs';
export { SelectInput } from './select-input/index.mjs';
export { Textarea } from './textarea/index.mjs';
export { Transfer } from './transfer/index.mjs';
export { TimePicker, TimePickerPanel, TimeRangePicker } from './time-picker/index.mjs';
export { TreeSelect } from './tree-select/index.mjs';
export { ColorPicker, ColorPickerPanel } from './color-picker/index.mjs';
export { RangeInput, RangeInputPopup } from './range-input/index.mjs';
export { Avatar, AvatarGroup } from './avatar/index.mjs';
export { Badge } from './badge/index.mjs';
export { Calendar } from './calendar/index.mjs';
export { Card } from './card/index.mjs';
export { Comment } from './comment/index.mjs';
export { Image } from './image/index.mjs';
export { ImageViewer } from './image-viewer/index.mjs';
export { List, ListItem, ListItemMeta } from './list/index.mjs';
export { Progress } from './progress/index.mjs';
export { Skeleton } from './skeleton/index.mjs';
export { Swiper, SwiperItem } from './swiper/index.mjs';
export { BaseTable, EnhancedTable, PrimaryTable, Table } from './table/index.mjs';
export { CheckTag, Tag } from './tag/index.mjs';
export { Timeline, TimelineItem } from './timeline/index.mjs';
export { Tooltip } from './tooltip/index.mjs';
export { Tree } from './tree/index.mjs';
export { Collapse, CollapsePanel } from './collapse/index.mjs';
export { Watermark } from './watermark/index.mjs';
export { Rate } from './rate/index.mjs';
export { Alert } from './alert/index.mjs';
export { DialogPlugin } from './dialog/plugin.mjs';
export { Dialog } from './dialog/index.mjs';
export { Drawer } from './drawer/index.mjs';
export { Guide } from './guide/index.mjs';
export { default as LoadingPlugin } from './loading/plugin.mjs';
export { Loading } from './loading/index.mjs';
export { default as MessagePlugin } from './message/plugin.mjs';
export { Message } from './message/index.mjs';
export { default as NotifyPlugin } from './notification/plugin.mjs';
export { Notification } from './notification/index.mjs';
export { Popconfirm } from './popconfirm/index.mjs';
export { Popup } from './popup/index.mjs';
export { Upload } from './upload/index.mjs';
export { ConfigProvider } from './config-provider/index.mjs';
import './button/button.mjs';
import './_chunks/dep-be6b014c.mjs';
import './_chunks/dep-558fadc3.mjs';
import './_chunks/dep-fa22eda7.mjs';
import './_chunks/dep-8a0ff305.mjs';
import 'vue';
import './button/props.mjs';
import './hooks/useRipple.mjs';
import './hooks/useKeepAnimation.mjs';
import './hooks/useConfig.mjs';
import './config-provider/useConfig.mjs';
import './_chunks/dep-1f286011.mjs';
import './_chunks/dep-34428f12.mjs';
import './_chunks/dep-1c40d002.mjs';
import './_chunks/dep-3ced59c9.mjs';
import './_chunks/dep-4371fb57.mjs';
import './_chunks/dep-31d34e52.mjs';
import './_chunks/dep-67e8723b.mjs';
import './_chunks/dep-0bf03d55.mjs';
import './_chunks/dep-5b5daf08.mjs';
import './_chunks/dep-95049222.mjs';
import './_chunks/dep-ac19a2b6.mjs';
import './_chunks/dep-90d97bcb.mjs';
import './_chunks/dep-c8679a16.mjs';
import './_chunks/dep-939a74d6.mjs';
import './_chunks/dep-61150968.mjs';
import './_chunks/dep-e9ff4ce8.mjs';
import './_chunks/dep-c54c9f32.mjs';
import './_chunks/dep-e4f65bc4.mjs';
import './_chunks/dep-45572c49.mjs';
import './_chunks/dep-1aa18f5f.mjs';
import './_chunks/dep-e09a06d8.mjs';
import './_chunks/dep-07f3660d.mjs';
import './_chunks/dep-0d3220b0.mjs';
import './_chunks/dep-895678a0.mjs';
import './_chunks/dep-b2bdc7b9.mjs';
import './_chunks/dep-0f45a6e0.mjs';
import './_chunks/dep-b390ff23.mjs';
import './_chunks/dep-35a4fd8d.mjs';
import './_chunks/dep-54378e60.mjs';
import './_chunks/dep-25b8bf4b.mjs';
import './_chunks/dep-c40264c0.mjs';
import './_chunks/dep-9d499243.mjs';
import './_common/js/global-config/default-config.mjs';
import './_common/js/global-config/locale/zh_CN.mjs';
import './_chunks/dep-0927ceb7.mjs';
import './_chunks/dep-f0bd05df.mjs';
import './config-provider/type.mjs';
import './utils/set-style.mjs';
import './hooks/tnode.mjs';
import './_chunks/dep-c25d13e7.mjs';
import './_chunks/dep-2a69909d.mjs';
import './_chunks/dep-c24f5c5d.mjs';
import './_chunks/dep-79d42d5d.mjs';
import './_chunks/dep-979d7716.mjs';
import './_chunks/dep-8b3be089.mjs';
import './_chunks/dep-84053b94.mjs';
import './_chunks/dep-398227bb.mjs';
import './utils/render-tnode.mjs';
import './_chunks/dep-55311368.mjs';
import './hooks/useDisabled.mjs';
import './_chunks/dep-44e322cb.mjs';
import './loading/directive.mjs';
import './loading/loading.mjs';
import './_chunks/dep-1ec078b3.mjs';
import './loading/icon/gradient.mjs';
import './_common/js/loading/circle-adapter.mjs';
import './_common/js/utils/set-style.mjs';
import './_common/js/utils/helper.mjs';
import './_chunks/dep-b9505f3d.mjs';
import './_chunks/dep-51567b45.mjs';
import './_chunks/dep-9a7888c7.mjs';
import './_chunks/dep-af8c0169.mjs';
import './utils/dom.mjs';
import './utils/easing.mjs';
import './loading/props.mjs';
import './hooks/useTeleport.mjs';
import './utils/withInstall.mjs';
import './style/css.mjs';
import './loading/type.mjs';
import './button/type.mjs';
import 'tdesign-icons-vue-next';
import './link/link.mjs';
import './form/hooks.mjs';
import './link/props.mjs';
import './link/type.mjs';
import './grid/row.mjs';
import './grid/row-props.mjs';
import './grid/common.mjs';
import './utils/responsive.mjs';
import './hooks/useListener.mjs';
import './grid/col.mjs';
import './grid/col-props.mjs';
import './grid/type.mjs';
import './layout/layout.mjs';
import './layout/header.mjs';
import './layout/header-props.mjs';
import './layout/footer.mjs';
import './layout/footer-props.mjs';
import './layout/aside.mjs';
import './layout/aside-props.mjs';
import './layout/content.mjs';
import './layout/type.mjs';
import './divider/divider.mjs';
import './divider/props.mjs';
import './divider/type.mjs';
import './space/space.mjs';
import './space/props.mjs';
import './hooks/slot.mjs';
import './space/type.mjs';
import './affix/affix.mjs';
import './_chunks/dep-4c1d0ada.mjs';
import './affix/props.mjs';
import './affix/type.mjs';
import './anchor/anchor.mjs';
import './anchor/utils.mjs';
import './anchor/props.mjs';
import './anchor/constants.mjs';
import './anchor/anchor-item.mjs';
import './anchor/anchor-item-props.mjs';
import './anchor/anchor-target.mjs';
import './utils/clipboard.mjs';
import './anchor/anchor-target-props.mjs';
import './hooks/useGlobalIcon.mjs';
import './message/messageList.mjs';
import './message/const.mjs';
import './message/message.mjs';
import './message/props.mjs';
import './message/animation.mjs';
import './popup/popup.mjs';
import '@popperjs/core';
import './_chunks/dep-a861ee00.mjs';
import './_chunks/dep-3514a375.mjs';
import './hooks/index.mjs';
import './hooks/icon.mjs';
import './hooks/useCommonClassName.mjs';
import './hooks/useDefaultValue.mjs';
import './hooks/useDestroyOnClose.mjs';
import './hooks/useVirtualScroll.mjs';
import './hooks/useVModel.mjs';
import './hooks/useImagePreviewUrl.mjs';
import './_common/js/upload/utils.mjs';
import './_common/js/log/log.mjs';
import './popup/container.mjs';
import './popup/props.mjs';
import './hooks/useResizeObserver.mjs';
import './popup/type.mjs';
import './anchor/type.mjs';
import './breadcrumb/breadcrumb.mjs';
import './breadcrumb/props.mjs';
import './breadcrumb/breadcrumb-item.mjs';
import './breadcrumb/breadcrumb-item-props.mjs';
import './tooltip/tooltip.mjs';
import './_chunks/dep-ad4331e8.mjs';
import './_chunks/dep-16b9f817.mjs';
import './_chunks/dep-e40749a5.mjs';
import './_chunks/dep-437754aa.mjs';
import './_chunks/dep-6dbd6c24.mjs';
import './tooltip/props.mjs';
import './tooltip/util.mjs';
import './tooltip/type.mjs';
import './breadcrumb/type.mjs';
import './dropdown/dropdown-item.mjs';
import './dropdown/dropdown-item-props.mjs';
import './utils/helper.mjs';
import './dropdown/dropdown.mjs';
import './dropdown/dropdown-menu.mjs';
import './dropdown/props.mjs';
import './dropdown/hooks/useDropdownOptions.mjs';
import './dropdown/type.mjs';
import './menu/menu.mjs';
import './menu/props.mjs';
import './menu/v-menu.mjs';
import './_chunks/dep-c6ef2029.mjs';
import './menu/head-menu.mjs';
import './menu/head-menu-props.mjs';
import './menu/submenu.mjs';
import './menu/submenu-props.mjs';
import './common-components/fake-arrow.mjs';
import './hooks/useCollapseAnimation.mjs';
import './tabs/tabs.mjs';
import './tabs/tab-panel.mjs';
import './tabs/tab-panel-props.mjs';
import './tabs/tab-nav.mjs';
import './tabs/props.mjs';
import './_common/js/tabs/base.mjs';
import './tabs/tab-nav-item.mjs';
import './tabs/tab-nav-bar.mjs';
import './hooks/useDragSort.mjs';
import './tabs/type.mjs';
import './menu/menu-item.mjs';
import './menu/menu-item-props.mjs';
import './utils/event.mjs';
import './menu/menu-group.mjs';
import './menu/menu-group-props.mjs';
import './menu/type.mjs';
import './pagination/pagination.mjs';
import './pagination/props.mjs';
import './pagination/usePaginationClasses.mjs';
import './pagination/useMoreAction.mjs';
import './input-number/input-number.mjs';
import './input-number/props.mjs';
import './input-number/useInputNumber.mjs';
import './_common/js/input-number/number.mjs';
import './_common/js/input-number/large-number.mjs';
import './_common/js/log/index.mjs';
import './input/input.mjs';
import './input/props.mjs';
import './input/useInput.mjs';
import './form/const.mjs';
import './input/useLengthLimit.mjs';
import './input/useInputEventHandler.mjs';
import './input/useInputWidth.mjs';
import './input/input-group.mjs';
import './input/input-group-props.mjs';
import './input/type.mjs';
import './input-number/type.mjs';
import './select/select.mjs';
import './_chunks/dep-e524ff2f.mjs';
import './_chunks/dep-6c1f8553.mjs';
import './_chunks/dep-154ff253.mjs';
import './_chunks/dep-e583fb66.mjs';
import './_chunks/dep-a059cf4b.mjs';
import './select/select-panel.mjs';
import './select/option.mjs';
import './select/option-props.mjs';
import './select/helper.mjs';
import './checkbox/checkbox.mjs';
import './checkbox/props.mjs';
import './checkbox/constants.mjs';
import './checkbox/hooks/useCheckboxLazyLoad.mjs';
import './_common/js/utils/observe.mjs';
import './checkbox/hooks/useKeyboard.mjs';
import './checkbox/group.mjs';
import './checkbox/checkbox-group-props.mjs';
import './checkbox/type.mjs';
import './select/optionGroup.mjs';
import './select/option-group-props.mjs';
import './select/props.mjs';
import './select/hooks/usePanelVirtualScroll.mjs';
import './select/hooks/useSelectOptions.mjs';
import './select-input/select-input.mjs';
import './select-input/props.mjs';
import './select-input/useSingle.mjs';
import './select-input/useMultiple.mjs';
import './tag-input/tag-input.mjs';
import './tag-input/props.mjs';
import './tag-input/hooks/useTagScroll.mjs';
import './tag-input/useTagList.mjs';
import './tag/tag.mjs';
import './tag/props.mjs';
import './tag/check-tag.mjs';
import './tag/check-tag-props.mjs';
import './tag/type.mjs';
import './tag-input/hooks/useHover.mjs';
import './tag-input/hooks/useDragSorter.mjs';
import './tag-input/type.mjs';
import './select-input/useOverlayInnerStyle.mjs';
import './select-input/type.mjs';
import './select/type.mjs';
import './input-adornment/input-adornment.mjs';
import './input-adornment/props.mjs';
import './input-adornment/type.mjs';
import './pagination/pagination-mini.mjs';
import './pagination/pagination-mini-props.mjs';
import './pagination/type.mjs';
import './steps/steps.mjs';
import './steps/props.mjs';
import './steps/step-item-props.mjs';
import './steps/step-item.mjs';
import './steps/type.mjs';
import './sticky-tool/sticky-tool.mjs';
import './sticky-tool/props.mjs';
import './sticky-tool/sticky-item.mjs';
import './sticky-tool/sticky-item-props.mjs';
import './sticky-tool/type.mjs';
import './back-top/back-top.mjs';
import './back-top/props.mjs';
import './back-top/type.mjs';
import './auto-complete/auto-complete.mjs';
import './auto-complete/props.mjs';
import './auto-complete/option-list.mjs';
import './auto-complete/highlight-option.mjs';
import './auto-complete/type.mjs';
import './cascader/cascader.mjs';
import './cascader/components/Panel.mjs';
import './cascader/components/Item.mjs';
import './cascader/core/helper.mjs';
import './cascader/core/className.mjs';
import './cascader/props.mjs';
import './cascader/core/effect.mjs';
import './cascader/hooks.mjs';
import './_chunks/dep-ddd676a1.mjs';
import './_chunks/dep-934f61a2.mjs';
import './_common/js/tree/tree-store.mjs';
import './_chunks/dep-534b0779.mjs';
import 'mitt';
import './_common/js/tree/tree-node.mjs';
import './_chunks/dep-2bbbe05a.mjs';
import './_common/js/tree/tree-node-model.mjs';
import './cascader/cascader-panel.mjs';
import './cascader/type.mjs';
import './date-picker/DatePicker.mjs';
import './date-picker/hooks/useSingle.mjs';
import './_common/js/date-picker/format.mjs';
import './_common/js/date-picker/utils.mjs';
import './_chunks/dep-c59fea99.mjs';
import './date-picker/hooks/useSingleValue.mjs';
import './date-picker/props.mjs';
import './date-picker/panel/SinglePanel.mjs';
import './date-picker/panel/PanelContent.mjs';
import './date-picker/base/Header.mjs';
import './date-picker/base/Table.mjs';
import './date-picker/base/Cell.mjs';
import './time-picker/panel/time-picker-panel.mjs';
import './_common/js/time-picker/const.mjs';
import './time-picker/panel/props.mjs';
import './time-picker/props.mjs';
import './time-picker/panel/single-panel.mjs';
import './_chunks/dep-44dd6c75.mjs';
import './_common/js/time-picker/utils.mjs';
import './date-picker/panel/ExtraContent.mjs';
import './date-picker/base/Footer.mjs';
import './date-picker/hooks/useTableData.mjs';
import './date-picker/hooks/useDisableDate.mjs';
import './date-picker/DatePickerPanel.mjs';
import './date-picker/date-picker-panel-props.mjs';
import './date-picker/DateRangePicker.mjs';
import './date-picker/date-range-picker-props.mjs';
import './date-picker/panel/RangePanel.mjs';
import './date-picker/hooks/useRange.mjs';
import './date-picker/hooks/useRangeValue.mjs';
import './range-input/range-input.mjs';
import './range-input/props.mjs';
import './range-input/range-input-popup.mjs';
import './range-input/range-input-popup-props.mjs';
import './range-input/type.mjs';
import './date-picker/DateRangePickerPanel.mjs';
import './date-picker/date-range-picker-panel-props.mjs';
import './date-picker/type.mjs';
import './form/form.mjs';
import './form/form-item.mjs';
import './_chunks/dep-4404b4d7.mjs';
import './form/form-model.mjs';
import './form/form-item-props.mjs';
import './form/props.mjs';
import './form/type.mjs';
import './radio/radio.mjs';
import './radio/props.mjs';
import './radio/constants.mjs';
import './radio/group.mjs';
import './_chunks/dep-3bc637e0.mjs';
import './radio/radio-group-props.mjs';
import './radio/useKeyboard.mjs';
import './watermark/hooks.mjs';
import './radio/radio-button.mjs';
import './radio/type.mjs';
import './slider/slider.mjs';
import './slider/props.mjs';
import './slider/slider-button.mjs';
import './slider/hooks/useSliderTooltip.mjs';
import './slider/util/common.mjs';
import './slider/util/constants.mjs';
import './slider/hooks/useSliderMark.mjs';
import './slider/slider-mark.mjs';
import './slider/hooks/useSliderInput.mjs';
import './slider/type.mjs';
import './switch/switch.mjs';
import './switch/props.mjs';
import './switch/type.mjs';
import './textarea/textarea.mjs';
import './textarea/calcTextareaHeight.mjs';
import './textarea/props.mjs';
import './textarea/type.mjs';
import './transfer/transfer.mjs';
import './transfer/components/transfer-list.mjs';
import './transfer/utils.mjs';
import './transfer/components/transfer-search.mjs';
import './transfer/components/transfer-operations.mjs';
import './transfer/props.mjs';
import './time-picker/time-picker.mjs';
import './time-picker/time-range-picker.mjs';
import './time-picker/time-range-picker-props.mjs';
import './time-picker/type.mjs';
import './tree-select/tree-select.mjs';
import './tree-select/props.mjs';
import './tree/td-tree.mjs';
import './tree/props.mjs';
import './tree/constants.mjs';
import './tree/useTree.mjs';
import './tree/tree-item.mjs';
import './tree/util.mjs';
import './tree/hooks/useDraggable.mjs';
import './tree/hooks/useOnDrag.mjs';
import './tree/hooks/useExposeFunc.mjs';
import './tree/type.mjs';
import './tree-select/interface.mjs';
import './tree-select/type.mjs';
import './color-picker/color-picker-panel.mjs';
import './color-picker/props.mjs';
import './color-picker/panel/index.mjs';
import './color-picker/const.mjs';
import './_common/js/color-picker/constants.mjs';
import './color-picker/panel/header.mjs';
import './color-picker/hooks.mjs';
import './color-picker/panel/linear-gradient.mjs';
import './color-picker/utils/index.mjs';
import './_common/js/color-picker/index.mjs';
import './_common/js/color-picker/cmyk.mjs';
import './_common/js/color-picker/color.mjs';
import './_chunks/dep-9f8df9b5.mjs';
import './_common/js/color-picker/draggable.mjs';
import './color-picker/panel/base-props.mjs';
import './color-picker/panel/saturation.mjs';
import './color-picker/panel/hue.mjs';
import './color-picker/panel/slider.mjs';
import './color-picker/panel/alpha.mjs';
import './color-picker/panel/format/index.mjs';
import './color-picker/panel/format/inputs.mjs';
import './color-picker/panel/format/config.mjs';
import './color-picker/panel/swatches.mjs';
import './color-picker/color-picker.mjs';
import './color-picker/trigger.mjs';
import './color-picker/type.mjs';
import './avatar/avatar.mjs';
import './avatar/props.mjs';
import './image/image.mjs';
import './image/props.mjs';
import './image/type.mjs';
import './avatar/group.mjs';
import './avatar/avatar-group-props.mjs';
import './avatar/type.mjs';
import './badge/badge.mjs';
import './badge/props.mjs';
import './badge/type.mjs';
import './calendar/calendar.mjs';
import './calendar/props.mjs';
import './calendar/utils.mjs';
import './calendar/const.mjs';
import './calendar/hook/index.mjs';
import './calendar/hook/useState.mjs';
import './calendar/hook/useCalendarClass.mjs';
import './calendar/hook/useController.mjs';
import './calendar/hook/useColHeaders.mjs';
import './calendar/calendar-cell.mjs';
import './calendar/type.mjs';
import './card/card.mjs';
import './card/props.mjs';
import './card/type.mjs';
import './comment/comment.mjs';
import './comment/props.mjs';
import './comment/type.mjs';
import './image-viewer/image-viewer.mjs';
import './image-viewer/props.mjs';
import './image-viewer/base/ImageModalIcon.mjs';
import './image-viewer/base/ImageViewerUtils.mjs';
import './image-viewer/utils.mjs';
import './image-viewer/base/ImageItem.mjs';
import './image-viewer/hooks.mjs';
import './image-viewer/base/ImageViewerModal.mjs';
import './dialog/dialog.mjs';
import './dialog/props.mjs';
import './dialog/hooks.mjs';
import './dialog/stack.mjs';
import './_common/js/utils/getScrollbarWidth.mjs';
import './dialog/type.mjs';
import './image-viewer/const.mjs';
import './image-viewer/type.mjs';
import './list/list.mjs';
import './list/props.mjs';
import './list/const.mjs';
import './list/list-item.mjs';
import './list/list-item-meta.mjs';
import './list/list-item-meta-props.mjs';
import './list/type.mjs';
import './progress/progress.mjs';
import './progress/constants.mjs';
import './progress/props.mjs';
import './progress/type.mjs';
import './skeleton/skeleton.mjs';
import './skeleton/props.mjs';
import './skeleton/type.mjs';
import './swiper/swiper.mjs';
import './swiper/props.mjs';
import './swiper/swiper-item.mjs';
import './swiper/type.mjs';
import './table/base-table.mjs';
import './table/base-table-props.mjs';
import './table/hooks/useTableHeader.mjs';
import './table/hooks/useMultiHeader.mjs';
import './table/hooks/useClassName.mjs';
import './table/ellipsis.mjs';
import './table/hooks/useColumnResize.mjs';
import './table/hooks/useFixed.mjs';
import './table/hooks/usePagination.mjs';
import './hooks/useVirtualScrollNew.mjs';
import './table/hooks/useAffix.mjs';
import './table/tbody.mjs';
import './table/tr.mjs';
import './table/utils.mjs';
import './table/hooks/useLazyLoad.mjs';
import './table/hooks/useRowspanAndColspan.mjs';
import './table/hooks/useStyle.mjs';
import './table/thead.mjs';
import './table/tfoot.mjs';
import './table/primary-table.mjs';
import './table/primary-table-props.mjs';
import './table/hooks/useColumnController.mjs';
import './table/hooks/useRowExpand.mjs';
import './table/hooks/useRowSelect.mjs';
import './_common/js/table/utils.mjs';
import './table/hooks/useSorter.mjs';
import './table/sorter-button.mjs';
import './table/hooks/useFilter.mjs';
import './table/filter-controller.mjs';
import './table/hooks/useDragSort.mjs';
import 'sortablejs';
import './_common/js/utils/swapDragArrayElement.mjs';
import './table/hooks/useAsyncLoading.mjs';
import './table/editable-cell.mjs';
import './_chunks/dep-dbbdd44f.mjs';
import './table/hooks/useEditableRow.mjs';
import './table/enhanced-table.mjs';
import './table/enhanced-table-props.mjs';
import './table/hooks/useTreeData.mjs';
import './_common/js/table/tree-store.mjs';
import './table/hooks/useTreeSelect.mjs';
import './table/type.mjs';
import './table/interface.mjs';
import './timeline/timeline.mjs';
import './timeline/props.mjs';
import './timeline/hooks.mjs';
import './timeline/timeline-item.mjs';
import './timeline/time-line-item-props.mjs';
import './timeline/type.mjs';
import './collapse/collapse.mjs';
import './collapse/props.mjs';
import './collapse/collapse-panel.mjs';
import './collapse/collapse-panel-props.mjs';
import './collapse/type.mjs';
import './watermark/watermark.mjs';
import './watermark/props.mjs';
import './_common/js/watermark/generateBase64Url.mjs';
import './_common/js/watermark/randomMovingStyle.mjs';
import './_common/js/utils/injectStyle.mjs';
import './watermark/type.mjs';
import './rate/rate.mjs';
import './rate/props.mjs';
import './rate/type.mjs';
import './alert/alert.mjs';
import './alert/props.mjs';
import './alert/type.mjs';
import './drawer/drawer.mjs';
import './drawer/props.mjs';
import './drawer/hooks.mjs';
import './drawer/type.mjs';
import './guide/guide.mjs';
import './guide/props.mjs';
import './guide/utils/index.mjs';
import './guide/utils/getScrollParent.mjs';
import './guide/utils/getRelativePosition.mjs';
import './guide/utils/getTargetElm.mjs';
import './guide/utils/scrollToElm.mjs';
import './guide/type.mjs';
import './message/type.mjs';
import './notification/notificationList.mjs';
import './notification/notification.mjs';
import './notification/props.mjs';
import './notification/animate.mjs';
import './notification/const.mjs';
import './notification/type.mjs';
import './popconfirm/popconfirm.mjs';
import './popconfirm/props.mjs';
import './popconfirm/type.mjs';
import './upload/upload.mjs';
import './upload/props.mjs';
import './upload/themes/normal-file.mjs';
import './upload/constants.mjs';
import './upload/themes/dragger-file.mjs';
import './upload/hooks/useDrag.mjs';
import './upload/themes/image-card.mjs';
import './upload/themes/multiple-flow-list.mjs';
import './upload/hooks/useUpload.mjs';
import './_common/js/upload/main.mjs';
import './_common/js/upload/xhr.mjs';
import './upload/themes/custom-file.mjs';
import './upload/interface.mjs';
import './upload/type.mjs';
import './config-provider/config-provider.mjs';

function install(app, config) {
  Object.keys(components).forEach(function (key) {
    /plugin/i.test(key) ? app.use(components[key]) : app.use(components[key], config);
  });
}
var index = {
  install: install,
  version: typeof "1.5.1" === "undefined" ? "" : "1.5.1"
};

export { index as default, install };
//# sourceMappingURL=index.mjs.map
